import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { Modal } from 'components/dialog/Modals'
import DetailCommon from 'features/editlog/layers/DetailCommon'
import DetailHasCreative from 'features/editlog/layers/DetailHasCreative'
import DetailHasAfter from 'features/editlog/layers/DetailHasAfter'
import DetailHasBeforeAfter from 'features/editlog/layers/DetailHasBeforeAfter'

const ACTION_HAS_CREATIVE = 'CREATIVE'
const ACTION_HAS_AFTER = 'AFTER'
const ACTION_HAS_BEFORE_AFTER = 'BEFORE_AFTER'

const DetailLayer = ({ on, handleClose }) => {
  const { hierarchy, historyDto } = useSelector(
    state => state.editlog.selectedDetail
  )
  const { showOnlyAfter, actions, aggregate } = historyDto
  const detailActionType =
    historyDto?.aggregate?.type === 'CREATIVE'
      ? ACTION_HAS_CREATIVE
      : showOnlyAfter
      ? ACTION_HAS_AFTER
      : ACTION_HAS_BEFORE_AFTER
  const hasWideLayout = useMemo(() => {
    if (historyDto?.aggregate?.type === 'CREATIVE') {
      return true
    }
    return (
      actions?.some(
        action =>
          action?.after?.impressionWeeklySchedule ||
          action?.type === 'ADGROUP_IMPRESSION_WEEKLY_SCHEDULE_CHANGE'
      ) || false
    )
  }, [historyDto, actions])
  return (
    <Modal
      on={on}
      className="iplimit_layer changehistory_layer"
      innerClassName={hasWideLayout ? 'inner_basic_layer2' : undefined}>
      <ConfirmModal
        title="상세보기"
        handleClose={handleClose}
        onCancel={handleClose}
        showCancelBtn={false}>
        <DetailCommon
          hierarchy={hierarchy}
          actionTypes={historyDto.actionTypes}>
          {detailActionType === ACTION_HAS_CREATIVE && (
            <DetailHasCreative
              actions={actions}
              hierarchy={hierarchy}
              subType={aggregate?.subType}
            />
          )}
          {detailActionType === ACTION_HAS_AFTER && (
            <DetailHasAfter
              aggregateType={aggregate?.type}
              subType={aggregate?.subType}
              actions={actions}
              hierarchy={hierarchy}
            />
          )}
          {detailActionType === ACTION_HAS_BEFORE_AFTER && (
            <DetailHasBeforeAfter />
          )}
        </DetailCommon>
      </ConfirmModal>
    </Modal>
  )
}

export default DetailLayer
DetailLayer.propTypes = {
  on: PropTypes.bool,
  handleClose: PropTypes.func,
}
